"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'avatar.form.knowledge.show': 'Mostra voci di conoscenza',
    'avatar.form.knowledge.label': 'Voci della Base di Conoscenza',
    'avatar.form.knowledge.search_placeholder': 'Cerca voci di conoscenza...',
    'avatar.form.knowledge.add': 'Aggiungi Nuova Conoscenza',
    'avatar.form.knowledge.fullscan': 'Scansione completa del documento',
    'avatar.form.title.edit': 'Modifica Avatar',
    'avatar.form.title.add': 'Aggiungi Avatar',
    'avatar.form.back': 'Indietro',
    'avatar.form.name.label': 'Nome',
    'avatar.form.name.placeholder': 'Nome dell\'avatar',
    'avatar.form.gender.label': 'Genere',
    'avatar.form.gender.placeholder': 'Seleziona genere',
    'avatar.form.gender.none': 'Nessuno',
    'avatar.form.gender.male': 'Maschio',
    'avatar.form.gender.female': 'Femmina',
    'avatar.form.age.label': 'Età',
    'avatar.form.age.placeholder': 'Età',
    'avatar.form.voice.label': 'Voce',
    'avatar.form.voice.placeholder': '-- Seleziona Voce --',
    'avatar.form.voice.male': 'Voci Maschili',
    'avatar.form.voice.female': 'Voci Femminili',
    'avatar.form.logo.label': 'Immagine avatar',
    'avatar.form.logo.placeholder': 'Invia immagine avatar',
    'avatar.form.instructionFile.label': 'File di Istruzioni',
    'avatar.form.instructionFile.placeholder': 'Carica file di istruzioni',
    'avatar.form.instructions.title': 'Istruzioni',
    'avatar.form.instructions.description': 'Gestisci le voci di istruzione che guidano il comportamento dell\'avatar. Ogni voce richiede un file allegato e può anche avere note e un prompt.',
    'avatar.form.error.instruction_file_required': 'Ogni voce di istruzione deve avere un file allegato.',
    'avatar.form.instructions.add': 'Aggiungi istruzione',
    'avatar.form.instructions.empty': 'Nessuna voce di istruzione. Clicca su "Aggiungi istruzione" per crearne una.',
    'avatar.form.instructions.untitled': 'Layer senza nome',
    'avatar.form.instructions.layer.label': 'Layer',
    'avatar.form.instructions.layer.placeholder': 'Inserisci nome del layer',
    'avatar.form.instructions.notes.label': 'Note',
    'avatar.form.instructions.notes.placeholder': 'Inserisci note di istruzione',
    'avatar.form.instructions.prompt.label': 'Prompt di istruzione',
    'avatar.form.instructions.prompt.placeholder': 'Inserisci prompt di istruzione',
    'avatar.form.instructions.file.label': 'File di istruzione',
    'avatar.form.instructions.isPublic.label': 'Pubblica (inclusa nei webhook)',
    'avatar.form.instructions.file.placeholder': 'Carica file di istruzione',
    'avatar.form.instructions.files.label': 'File di istruzioni',
    'avatar.form.instructions.files.placeholder': 'Carica file di istruzioni',
    'avatar.form.instructions.versions.title': 'Cronologia versioni',
    'avatar.form.instructions.versions.show': 'Mostra cronologia versioni',
    'avatar.form.instructions.versions.hide': 'Nascondi cronologia versioni',
    'avatar.form.instructions.versions.empty': 'Nessuna versione precedente disponibile.',
    'avatar.form.instructions.versions.restore': 'Ripristina',
    'avatar.form.instructions.versions.restore_confirm': 'Sei sicuro di voler ripristinare questa versione? Le modifiche attuali verranno sovrascritte.',
    'avatar.form.description.label': 'Descrizione',
    'avatar.form.description.placeholder': 'Descrizione',
    'avatar.form.model.label': 'Modello',
    'avatar.form.model.placeholder': 'Seleziona modello',
    'avatar.form.knowledge.placeholder': 'Seleziona voci di conoscenza',
    'avatar.form.submit.update': 'Aggiorna Avatar',
    'avatar.form.submit.create': 'Crea Avatar',
    'avatar.form.submit.saveAndReturn.update': 'Salva Avatar e torna alla lista',
    'avatar.form.submit.saveAndReturn.create': 'Crea Avatar e torna alla lista',
    'avatar.form.tab.configuration': 'Configurazione',
    'avatar.form.tab.knowledge': 'Base di Conoscenza',
    'avatar.form.tab.instructions': 'Istruzioni',
    'avatar.form.tab.tools': 'Strumenti',
    'avatar.form.tab.webhooks': 'Webhooks',
    'avatar.form.tab.lexicon': 'Lessico',
    'avatar.form.timed.label': 'Abilita disponibilità basata sul tempo',
    'avatar.form.timed.help': 'Limita quando questo avatar è disponibile',
    'avatar.form.startTime.label': 'Disponibile da',
    'avatar.form.startTime.placeholder': 'Seleziona data di inizio',
    'avatar.form.endTime.label': 'Disponibile fino a',
    'avatar.form.endTime.placeholder': 'Seleziona data di fine',
    'avatar.form.webhooks.config.title': 'Configurazione Webhooks',
    'avatar.form.webhooks.config.description': 'Configura le impostazioni di autorizzazione per tutti gli endpoint webhook',
    'avatar.form.webhooks.config.authHeader.label': 'Header di Autorizzazione',
    'avatar.form.webhooks.config.authHeader.placeholder': 'es. Authorization',
    'avatar.form.webhooks.config.authKey.label': 'Chiave di Autorizzazione',
    'avatar.form.webhooks.config.authKey.placeholder': 'Token Bearer o chiave API',
    'avatar.form.webhooks.definitions.title': 'Definizioni Webhooks',
    'avatar.form.webhooks.definitions.add': 'Aggiungi Webhook',
    'avatar.form.webhooks.definitions.empty': 'Nessuna definizione webhook configurata. Clicca "Aggiungi Webhook" per crearne una.',
    'avatar.form.webhooks.definitions.untitled': 'Webhook Senza Titolo',
    'avatar.form.webhooks.definitions.name.label': 'Nome Webhook',
    'avatar.form.webhooks.definitions.name.placeholder': 'Inserisci nome webhook',
    'avatar.form.webhooks.definitions.address.label': 'URL Webhook',
    'avatar.form.webhooks.definitions.address.placeholder': 'https://tuo-endpoint.com/webhook',
    'avatar.form.webhooks.definitions.eventType.label': 'Tipo di Evento',
    'avatar.form.webhooks.definitions.cronInterval.label': 'Intervallo Cron',
    'avatar.form.webhooks.definitions.cronInterval.placeholder': '*/30 * * * *',
    'avatar.form.webhooks.definitions.cronInterval.help': 'Espressione cron (es. */30 * * * * = ogni 30 minuti)',
    'avatar.form.webhooks.definitions.cronEnabled.label': 'Abilita Cron',
    'avatar.form.webhooks.definitions.active.label': 'Attivo',
    'avatar.form.webhooks.definitions.authEnabled.label': 'Abilita Autorizzazione',
    'avatar.form.webhooks.definitions.authHeader.label': 'Header di Autorizzazione',
    'avatar.form.webhooks.definitions.authHeader.placeholder': 'es. Authorization',
    'avatar.form.webhooks.definitions.authKey.label': 'Chiave di Autorizzazione',
    'avatar.form.webhooks.definitions.authKey.placeholder': 'Token Bearer o chiave API',
    'avatar.form.webhooks.payload.title': 'Esempio di Payload',
    'avatar.form.webhooks.payload.subtitle': 'Esempio di payload JSON per questo tipo di evento webhook',
    'avatar.form.webhooks.payload.description': 'Questa è la struttura dei dati JSON che verranno inviati al tuo endpoint webhook.',
    'avatar.form.lexicon.title': 'Voci del Lessico',
    'avatar.form.lexicon.add': 'Aggiungi Voce',
    'avatar.form.lexicon.empty': 'Nessuna voce del lessico configurata. Clicca su "Aggiungi Voce" per crearne una.',
    'avatar.form.lexicon.untitled': 'Voce Senza Titolo',
    'avatar.form.lexicon.hidden': 'Nascosto',
    'avatar.form.lexicon.label.label': 'Etichetta',
    'avatar.form.lexicon.label.placeholder': 'Inserisci termine o parola',
    'avatar.form.lexicon.value.label': 'Definizione',
    'avatar.form.lexicon.value.placeholder': 'Inserisci definizione o spiegazione',
    'avatar.form.lexicon.hidden.label': 'Nascosto',
    'avatar.form.lexicon.hidden.help': 'Quando abilitato, questa voce non sarà visibile agli utenti ma sarà utilizzata dall\'avatar per la comprensione',
    'avatar.form.tab.apiTools': 'Strumenti API',
    'avatar.form.apiTools.title': 'Strumenti API',
    'avatar.form.apiTools.description': 'Configura gli endpoint API esterni che l\'IA può chiamare durante le conversazioni',
    'avatar.form.apiTools.enabled.label': 'Abilita strumenti API',
    'avatar.form.apiTools.enabled.help': 'Consenti all\'avatar di effettuare chiamate a endpoint API esterni',
    'avatar.form.apiTools.list.title': 'Endpoint API',
    'avatar.form.apiTools.add': 'Aggiungi Endpoint',
    'avatar.form.apiTools.empty': 'Nessun endpoint API configurato. Clicca su "Aggiungi Endpoint" per crearne uno.',
    'avatar.form.apiTools.untitled': 'Endpoint Senza Titolo',
    'avatar.form.apiTools.name.label': 'Nome',
    'avatar.form.apiTools.name.placeholder': 'Inserisci nome endpoint',
    'avatar.form.apiTools.endpoint.label': 'URL Endpoint',
    'avatar.form.apiTools.endpoint.placeholder': 'https://api.example.com/endpoint',
    'avatar.form.apiTools.method.label': 'Metodo',
    'avatar.form.apiTools.description.label': 'Descrizione',
    'avatar.form.apiTools.description.placeholder': 'Descrivi cosa fa questo endpoint API',
    'avatar.form.apiTools.description.help': 'Una descrizione aiuta l\'IA a capire quando e come usare questo endpoint',
    'avatar.form.apiTools.authEnabled.label': 'Abilita Autorizzazione',
    'avatar.form.apiTools.authHeader.label': 'Header Autorizzazione',
    'avatar.form.apiTools.authHeader.placeholder': 'es. Authorization',
    'avatar.form.apiTools.authKey.label': 'Chiave Autorizzazione',
    'avatar.form.apiTools.authKey.placeholder': 'Token Bearer o chiave API',
    'avatar.form.apiTools.authKey.toggle': 'Mostra/Nascondi chiave',
    'avatar.form.apiTools.payloadFields.title': 'Campi Payload',
    'avatar.form.apiTools.payloadFields.add': 'Aggiungi Campo',
    'avatar.form.apiTools.payloadFields.description': 'Definisci i campi che l\'IA compilerà quando chiama questo endpoint',
    'avatar.form.apiTools.payloadFields.empty': 'Nessun campo payload definito. Clicca su "Aggiungi Campo" per crearne uno.',
    'avatar.form.apiTools.payloadFields.name.label': 'Nome Campo',
    'avatar.form.apiTools.payloadFields.name.placeholder': 'es. query',
    'avatar.form.apiTools.payloadFields.desc.label': 'Descrizione Campo',
    'avatar.form.apiTools.payloadFields.desc.placeholder': 'Descrivi a cosa serve questo campo in modo che l\'IA sappia come compilarlo',
    'avatar.form.apiTools.payloadFields.type.label': 'Tipo',
    'avatar.form.apiTools.payloadFields.optional.label': 'Opzionale',
    'avatar.form.tools.title': 'Strumenti Disponibili',
    'avatar.form.tools.description': 'Seleziona quali strumenti questo avatar può usare durante le conversazioni',
    'avatar.form.error.load_failed': 'Errore nel caricamento dell\'avatar',
    'avatar.form.error.model_required': 'Il modello è richiesto',
    'avatar.form.error.action_failed': 'Azione fallita',
    'avatar.form.error.general_error': 'Si è verificato un errore',
    'avatar.form.action.updated': 'aggiornato',
    'avatar.form.action.created': 'creato',
    'avatar.form.action.update': 'aggiorna',
    'avatar.form.action.create': 'crea',
    'avatar.form.success.updated': 'Avatar aggiornato con successo',
    'avatar.form.success.action_completed': 'Azione avatar completata con successo',
};
